/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the Antoine equation?`)
};

const es_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es la ecuación de Antoine?`)
};

const de_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist die Antoine-Gleichung?`)
};

const nl_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de Antoine-vergelijking?`)
};

const fr_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que l'équation d'Antoine ?`)
};

const it_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è l'equazione di Antoine?`)
};

const pt_br2_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a equação de Antoine?`)
};

const pt_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a equação de Antoine?`)
};

const ja_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アントワン式とは何ですか?`)
};

const zh_bp_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是安托万方程？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bp_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bp_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bp_faq_q2", locale)
	if (locale === "en") return en_bp_faq_q2(inputs)
	if (locale === "es") return es_bp_faq_q2(inputs)
	if (locale === "de") return de_bp_faq_q2(inputs)
	if (locale === "nl") return nl_bp_faq_q2(inputs)
	if (locale === "fr") return fr_bp_faq_q2(inputs)
	if (locale === "it") return it_bp_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_bp_faq_q2(inputs)
	if (locale === "pt") return pt_bp_faq_q2(inputs)
	if (locale === "ja") return ja_bp_faq_q2(inputs)
	return zh_bp_faq_q2(inputs)
};